// pgw 05-may-2026 - testing ugc
import {
  isUgcTestingEnabled,
  getUgcLibrarySongs,
  fetchRemoteUgcLibrarySongs,
} from "../../utils/ugcTesting";


let cachedResults = null;

// pgw 03-apr-2025
let doprint = false;

// pgw 20-apr-2026 - testing CG integration
import { getCgSonglistUrl } from "../../utils/cgTesting";

// pgw 30-mar-2025 add random query string as cache-buster
function cacheBustingUrl(url) {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}cb=${Date.now()}`;
}


export async function fetchLibrarySongs(startIndex, limit, searchTerm, activeFilters, clientConfig) {
  try {

	  // pgw 05-may-2026 - testing ugc
	  if (isUgcTestingEnabled()) {

		let songs = await fetchRemoteUgcLibrarySongs();

		if (doprint) {
			console.log("[UGC] fetchLibrarySongs using fresh remote songlist =", songs.map((song) => ({
			  songId: song.songId,
			  mix: song.mix,
			  chaptersCount: song.chapters?.length || 0,
			  lyrics: song.lyrics,
			  lyricsUrl: song.lyricsUrl,
			})));
		}


		if (!songs.length) {
		  songs = getUgcLibrarySongs();
		}

		songs = songs.map((song) => ({
		  ...song,
		  lyricsUrl: song.lyricsUrl || song.lyrics || "",
		  lyrics: song.lyrics || song.lyricsUrl || "",
		  chapters: Array.isArray(song.chapters) ? song.chapters : [],
		}));


		if (searchTerm) {
		  songs = songs.filter(song =>
			(song.artist || "").toLowerCase().includes(searchTerm) ||
			(song.mix || "").toLowerCase().includes(searchTerm) ||
			song.songId === searchTerm
		  );
		}

		return {
		  data: songs.slice(startIndex, limit),
		};
	  }



      let songsJson;

		if (doprint) console.log("pgw fetchLibrarySongs startIndex = ", startIndex); 
		if (doprint) console.log("pgw fetchLibrarySongs limit = ", limit); 
		if (doprint) console.log("pgw fetchLibrarySongs searchTerm = ", searchTerm); 

		// pgw 04-apr-2023 test with timeout of 20 seconds
	  //   const response = await fetch(clientConfig.features.library.endpoint);


		// pgw 30-mar-2025 add random query string as cache-buster
		// const response = await fetch(clientConfig.features.library.endpoint, { timeout: 20000 });


		// pgw 15-aug-2025 - remove cache bust call for now (so that songlist can be cached for offline)
		// const uniqueEndpoint = cacheBustingUrl(clientConfig.features.library.endpoint)
		// const uniqueEndpoint = clientConfig.features.library.endpoint

		// pgw 20-apr-2026 - testing CG integration
		const uniqueEndpoint = getCgSonglistUrl(clientConfig.features.library.endpoint);

		if (doprint) console.log("pgw clientConfig.features.library.endpoint = ", clientConfig.features.library.endpoint); 
		if (doprint) console.log("pgw uniqueEndpoint = ", uniqueEndpoint); 


		if (doprint) console.log("pgw clientConfig.features.library.endpoint = ", clientConfig.features.library.endpoint); 
		if (doprint) console.log("pgw uniqueEndpoint = ", uniqueEndpoint); 

      	// pgw 20-apr-2026 - testing CG integration
      	// const response = await fetch(uniqueEndpoint, { timeout: 20000 });

      const endpoint = getCgSonglistUrl(clientConfig.features.library.endpoint);


		if (doprint) console.log("pgw endpoint = ", endpoint); 

      const response = await fetch(endpoint, { timeout: 20000 });
      if (response.status === 200) {
        songsJson = await response.json();
		if (doprint) console.log("pgw songsJson = ", songsJson); 


      } else {
        throw new Error('Library request failed');
      }
    
      let songs = Array.from(new Set(songsJson));
      songs = songs.filter(song => song.songId !== 's3fm0063_0301'); // filer out the odd duplicate in the reponse
      
		if (doprint) console.log("pgw 1 songs = ", songs); 


      //temporary filter to exclude songs that dont play
      songs = songs.filter(song => !clientConfig.features.library.songsToHide.includes(song.songId));

		if (doprint) console.log("pgw 2 songs = ", songs); 

      // songs = songs.sort((a,b)=> { 
      //   return config.WORKING_ON_IOS.indexOf(b.songId) - config.WORKING_ON_IOS.indexOf(a.songId)
      // });

      if (searchTerm) {
        songs = songs.filter(song => (song.artist.toLowerCase().includes(searchTerm) || song.mix.toLowerCase().includes(searchTerm) || song.songId === searchTerm))
      }
      if (activeFilters) {
        if (activeFilters.genres.length) {
          songs = songs.filter(song => activeFilters.genres.includes(song.genre));
        }
        if (activeFilters.keySignatures.length) {
          songs = songs.filter(song => activeFilters.keySignatures.includes(song.key));
        } 
        if (activeFilters.decades.length) {
          songs = songs.filter(song => activeFilters.decades.includes(song.decade));
        }
      }

		if (doprint) console.log("pgw 3 songs = ", songs); 


      return {
        data: songs.slice(startIndex, limit)
      };
      
        
      
    
  } catch (e) {
    console.error(e);
    throw new Error(e.message);
  }
}

export async function fetchLibrarySongsById(songIds, clientConfig) {
  try {

	// localStorage.setItem("ugcTesting", "1");
	// pgw 05-may-2026 - testing ugc
	if (isUgcTestingEnabled()) {

	  let songs = await fetchRemoteUgcLibrarySongs();

	  if (doprint) {
		  console.log("[UGC] fetchLibrarySongsById using fresh remote songlist =", songs.map((song) => ({
			songId: song.songId,
			mix: song.mix,
			chaptersCount: song.chapters?.length || 0,
			lyrics: song.lyrics,
			lyricsUrl: song.lyricsUrl,
		  })));
	  }

	  if (!songs.length) {
		songs = getUgcLibrarySongs();
	  }

	  songs = songs.map((song) => ({
		...song,
		lyricsUrl: song.lyricsUrl || song.lyrics || "",
		lyrics: song.lyrics || song.lyricsUrl || "",
		chapters: Array.isArray(song.chapters) ? song.chapters : [],
	  }));



	  return {
		data: songIds
		  .map(id => songs.find(song => song.songId === id))
		  .filter(Boolean),
	  };
	}

	// pgw 30-mar-2025 add random query string as cache-buster
	if (doprint) console.log("pgw fetchLibrarySongsById cachedResults = ", cachedResults); 

    if (!cachedResults) {
	// pgw 04-apr-2023 test with timeout of 20 seconds
//       const response = await fetch(clientConfig.features.library.endpoint);
      const response = await fetch(clientConfig.features.library.endpoint, { timeout: 20000 });
      if (response.status === 200) {
        cachedResults = await response.json();
      } else {
        throw new Error('Library request failed');
      }
    }
      let songs = Array.from(new Set(cachedResults));
      
      let results = [];
      
      //temporary filter to exclude songs that dont play
      songs = songs.filter(song => !clientConfig.features.library.songsToHide.includes(song.songId));

      for (const id of songIds) {
        const foundSong = songs.find(s => s.songId === id);
        if (foundSong) {
          results.push(foundSong);
        }
      }

      return {
        data: results
      };    
  } catch (e) {
    console.error(e);
    throw new Error(e.message);
  }
}
